export default __webpack_public_path__ + "static/media/trekking.a9d68156.jpg";